import React, { useCallback, useEffect, useState } from "react";
import { Tables } from "../../../components/Elements/Tables/Tables";
import CustomSwitch from "../../../components/Elements/CustomSwitch/CustomSwitch";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as EditIcon } from "../../../assets/svgs/edit-icon.svg";
import { ReactComponent as BackIcon } from "../../../assets/svgs/back-button.svg";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import CustomerAddNewSubSection from "./Roles/DIalogBoxes/CustomerAddNewSubSection";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
import CustomerQuestionsTable from "./CustomerQuestionsTable";
import CustomerUpdateSubSection from "./CustomerUpdateSubSection";
import { Badge } from "../../../components/Elements/TextStyles/Badge";

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const CustomerSubSection = ({ sectionId, clientId, setSubSectionOpen }) => {
  const [tableData, setTableData] = useState([]);
  const [openAddNew, setOpenAddNew] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [subSectionId, setSubSectionId] = useState("");
  const [subSectionName, setSubSectionName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [subSectionCreated, setSubSectionCreated] = useState(false);
  const [subSectionUpdated, setSubSectionUpdated] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [popupData, setPopupData] = useState(null);
  const [openQuestion, setOpenQuestions] = useState(false);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Sub Section", key: "subSection" },
    { label: "Status", key: "status" },
    { label: "Action", key: "action" },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchSubSections = async () => {
    if (!sectionId || !clientId) return;

    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOMER_SUBSECTION(sectionId),
        headers: { client: clientId },
      }); // set showError to true for toast

      if (response.success) {
        const mappedData = response.data.map((item, index) => ({
          key: item._id,
          serial: <div>{index + 1}</div>,
          subSection: <div>{item.name}</div>,
          status: (
            <div className="flex justify-center">
              <Badge text={item.status} />
            </div>
          ),
          action: (
            <div className="flex gap-4 justify-center items-center">
              <GreenEye
                className="cursor-pointer"
                onClick={() => {
                  setOpenQuestions(true);
                  setSubSectionId(item._id);
                  setSubSectionName(item.name);
                }}
              />
              <EditIcon
                className="cursor-pointer"
                onClick={() => {
                  setOpenUpdate(true);
                  setSubSectionId(item._id);
                  setSubSectionName(item.name);
                }}
              />
              <CustomSwitch
                checked={item.status === "Active"}
                onChange={(checked) => console.log(`Toggle Status: ${checked}`)}
              />
            </div>
          ),
        }));

        setTableData(mappedData);
      }
    } catch (error) {
      console.error("❌ Failed to fetch sub-sections", error);
    }
  };

  useEffect(() => {
    fetchSubSections();
  }, [sectionId, clientId]);

  const filteredData = tableData.filter((item) =>
    item.subSection?.props?.children
      ?.toString()
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (popupData) {
      const timer = setTimeout(() => {
        setPopupData(null);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popupData]);

  return (
    <div className="">
      {!openQuestion && (
        <div>
          <div className="flex  px-6 items-center  pb-2">
            <BackIcon onClick={() => setSubSectionOpen(false)} />
            <p className="text-[#06513D]  text-xl my-auto">Sub Sections</p>
          </div>
          <div className="flex justify-between items-center mb-4 px-8">
            <div className="flex flex-col sm:flex-row gap-3 sm:items-center w-full sm:w-auto">
              <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
                Total Sub Sections {tableData.length}
              </div>
              <SearchBar
                onSearch={(value) => setSearchTerm(value)}
                width="100%"
                className="w-full sm:w-[300px]"
              />
            </div>
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="+ ADD NEW"
              className="text-sm h-[50px]"
              onClick={() => setOpenAddNew(true)}
            />
          </div>

          {/* Table or Cards */}
          <div className="px-2 overflow-x-auto">
            {isMobile ? (
              <div>
                {filteredData.map((item) => (
                  <div
                    key={item.key}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={cardVariants}
                    transition={{ duration: 0.3 }}
                    className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300"
                  >
                    <div className="flex justify-between mb-2">
                      <span className="font-semibold text-[#06513D]">
                        Sub Section
                      </span>
                      <span className="font-semibold text-[#06513D]">
                        {item.subSection}
                      </span>
                    </div>
                    <div className="flex justify-between items-center mb-3">
                      <span>Status</span>
                      <Badge text={item.statusText} />
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="flex gap-4">
                        <GreenEye className="cursor-pointer" />
                        <EditIcon
                          className="cursor-pointer"
                          onClick={() => {
                            setOpenUpdate(true);
                            setSubSectionId(item.key);
                            setSubSectionName(item.subSection);
                          }}
                        />
                      </div>
                      <CustomSwitch
                        checked={true}
                        onChange={(checked) =>
                          console.log(`Custom switch toggled: ${checked}`)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <Tables data={tableData} headers={headers} />
            )}
          </div>

          {/* Dialogs */}
          {openAddNew && (
            <CustomerAddNewSubSection
              onOpen={openAddNew}
              onClose={() => {
                setOpenAddNew(false);
                fetchSubSections();
              }}
              sectionId={sectionId}
              clientId={clientId}
              popupData={popupData}
              setPopupData={setPopupData}
              setSubSectionCreated={setSubSectionCreated}
            />
          )}
          {openUpdate && (
            <CustomerUpdateSubSection
              onOpen={openUpdate}
              onClose={() => {
                setOpenUpdate(false);
                fetchSubSections();
              }}
              subSectionId={subSectionId}
              subSectionName={subSectionName}
              clientId={clientId}
              popupData={popupData}
              setPopupData={setPopupData}
              setSubSectionUpdated={setSubSectionUpdated}
            />
          )}
        </div>
      )}
      {openQuestion && (
        <CustomerQuestionsTable
          sectionId={sectionId}
          subsectionId={subSectionId}
          clientId={clientId}
          setQuestionOpen={setOpenQuestions}
        />
      )}

      {popupData && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}
    </div>
  );
};

export default CustomerSubSection;
